import { createApp, defineAsyncComponent } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import axios from 'axios';
import { createPinia } from 'pinia';

import VueDatePicker from '@vuepic/vue-datepicker';
import VueSelect from 'vue-select';
import Vue3Tour from 'vue3-tour';
import Avatar from 'vue3-avatar';
import Popper from 'vue3-popper';
import * as Sentry from '@sentry/vue';

import 'vue3-tour/dist/vue3-tour.css';
import Home from './components/home/Home.vue';

import ChooseClient from './components/home/ChooseClient.vue';
import TreeReport from '@/components/tree-reports/TreeReport.vue';
import { preloadImages } from '@/config/ForestreeIconFactory.js';

// setup axios
let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
    axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

await preloadImages()
const app = createApp();

if(import.meta.env.MODE === 'production') {
    Sentry.init({
        app,
        dsn: 'https://dddf859e1ef4f2100e94bb919ac0334c@o239344.ingest.us.sentry.io/4509291350065152',
        release: 'dev',
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        environment: import.meta.env.MODE,
    });
}

app.component('VueDatePicker', VueDatePicker);
app.component('v-select', VueSelect);
app.component('avatar', Avatar);
app.component('popper', Popper);

const pinia = createPinia();

const router = createRouter({
    history: createWebHistory(),
    routes: []
});


app.use(router);
app.use(Vue3Tour);
app.use(pinia);

app.component('general', Home);
app.component('choose-client', ChooseClient);
app.component('tree-report', TreeReport);

app.component('map-control', defineAsyncComponent(() =>
    import('@/components/maps/inspection/InspectionMap.vue')
));
app.component('maintenance-map', defineAsyncComponent(() =>
    import('@/components/maps/works/WorksMap.vue')
));
app.component('vacant-map', defineAsyncComponent(() =>
    import('@/components/maps/planting/PlantingMap.vue')
));
app.component('stumps-map', defineAsyncComponent(() =>
    import('@/components/maps/stumps/StumpsMap.vue')
));
app.component('watering-map', defineAsyncComponent(() =>
    import('@/components/maps/watering/WateringMap.vue')
));
app.component('reporting', defineAsyncComponent(() =>
    import('./components/home/reporting/ReportingMain.vue')
));
app.component('settings-home', defineAsyncComponent(() =>
    import('./components/home/settings/SettingsHome.vue')
));

app.component('projects-works-map', defineAsyncComponent(() =>
    import('./components/maps/projects/ProjectWorksMap.vue')
));

app.component('projects-list', defineAsyncComponent(() =>
    import('./components/maps/projects/ProjectList.vue')
));
app.component('projects-summary', defineAsyncComponent(() =>
    import('./components/maps/projects/ProjectSummary.vue')
));

app.component('contractor-general', defineAsyncComponent(() =>
    import('./components/legacy/contractor/ContractorGeneral.vue')
));
app.component('contractor-map', defineAsyncComponent(() =>
    import('./components/legacy/contractor/map/contractorMap.vue')
));
app.component('storm-home', defineAsyncComponent(() =>
    import('./components/stormee/StormHome.vue')
));

app.config.errorHandler = (err) => {
    console.error('Vue app error:', err);
};

try {
    app.mount('#app');

} catch (error) {
    console.error('Mount failed:', error);
}